import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-field"
export default class extends Controller {
  static targets = ["select", "dependent"]
  static values = { showValue: String } // the value that triggers showing the dependent field

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.selectTarget.value === this.showValueValue) {
      this.dependentTarget.classList.remove("hidden")
    } else {
      this.dependentTarget.classList.add("hidden")
    }
  }
}
